module.exports = "<div> <a class=\"btn btn btn-zillwhite btn-veld-rounded mb10\" ng-click=openRelation() ng-if=content.title> <smart-icon url={{content.icon.url}} width=12px height=12px color=#939393 style=display:inherit></smart-icon> {{content.title}} </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./web/js/module/visionText/js/referenceButton/referenceButton.html
// module id = 1107
// module chunks = 0